import { SupplierBookingWebService as BookingWebService } from '@linktivity/gds-neo';

export const CancelBookingCancellerEnum = BookingWebService.Canceller;
export type CancelBookingCancellerEnum = BookingWebService.Canceller;

export const DiscrepancyStatus = BookingWebService.DiscrepancyStatus;
export type DiscrepancyStatus = BookingWebService.DiscrepancyStatus;
export const DiscrepancyWaitingStatus =
  BookingWebService.DiscrepancyWaitingStatus;
export type DiscrepancyWaitingStatus =
  BookingWebService.DiscrepancyWaitingStatus;
export const DiscrepancyInitiator = BookingWebService.DiscrepancyInitiator;
export type DiscrepancyInitiator = BookingWebService.DiscrepancyInitiator;
export const DiscrepancyType = BookingWebService.DiscrepancyType;
export type DiscrepancyType = BookingWebService.DiscrepancyType;

export const BookingType =
  BookingWebService.ListBookingsWithPageBookingTypeEnum;
export type BookingType = BookingWebService.ListBookingsWithPageBookingTypeEnum;

export const BulkBookingModelStatus = BookingWebService.BulkBookingModelStatus;
export type BulkBookingModelStatus = BookingWebService.BulkBookingModelStatus;

export const DateMode = BookingWebService.DateMode;
export type DateMode = BookingWebService.DateMode;

export const OutputMode = BookingWebService.OutputMode;
export type OutputMode = BookingWebService.OutputMode;
